var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 1.83317C0.666016 1.18884 1.18835 0.666504 1.83268 0.666504H18.166C18.8103 0.666504 19.3327 1.18884 19.3327 1.83317V4.1665C19.3327 4.81084 18.8103 5.33317 18.166 5.33317H1.83268C1.18835 5.33317 0.666016 4.81084 0.666016 4.1665V1.83317Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 11.1665C0.666016 10.5222 1.18835 9.99984 1.83268 9.99984H8.83268C9.47702 9.99984 9.99935 10.5222 9.99935 11.1665V18.1665C9.99935 18.8108 9.47702 19.3332 8.83268 19.3332H1.83268C1.18835 19.3332 0.666016 18.8108 0.666016 18.1665V11.1665Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 11.1665C14.666 10.5222 15.1884 9.99984 15.8327 9.99984H18.166C18.8103 9.99984 19.3327 10.5222 19.3327 11.1665V18.1665C19.3327 18.8108 18.8103 19.3332 18.166 19.3332H15.8327C15.1884 19.3332 14.666 18.8108 14.666 18.1665V11.1665Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.e7576f899ac8ad5f02211bef709f49dd.svg";
export { ForwardRef as ReactComponent };